export default "__VITE_ASSET__CO40ggyW__"